import { render, staticRenderFns } from "./dtp-blurring-videos-page.vue?vue&type=template&id=0296305b&scoped=true"
import script from "./dtp-blurring-videos-page.vue?vue&type=script&lang=js"
export * from "./dtp-blurring-videos-page.vue?vue&type=script&lang=js"
import style0 from "./dtp-blurring-videos-page.vue?vue&type=style&index=0&id=0296305b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296305b",
  null
  
)

export default component.exports